import agendaApiConfig from "./agendaApiConfig";

const SucursalService = {
  async getAll() {
    let query = {};
    if (process.env.REACT_APP_SERVICIO == "") {
      query = null;
    } else {
      query = { ser_codigo: process.env.REACT_APP_SERVICIO };
    }
    return await agendaApiConfig.get("/sucursal", {
      params: {
        ...query,
      },
    });
  },

  async getBySueCorrel(sueCorrel, staCorrel = 1) {
    return await agendaApiConfig.get("/v2/sucursal", {
      params: {
        suecorrel: sueCorrel,
        stacorrel: staCorrel,
      },
      headers: {
        "X-Origin": process.env.REACT_APP_HEADER,
      },
    });
  },
};

export default SucursalService;
